import {RefObject} from "react";
import {ActionMeta, MultiValue, OnChangeValue, PropsValue} from "react-select";

import {MonitoringGroup, MonitoringGroupLevel} from "@/lib/types/monitoring.ts";
import {LimitCheckerComponent} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

const limitChangesHandler = (
  data: OnChangeValue<MonitoringGroup, boolean>,
  actionMeta: ActionMeta<MonitoringGroup>,
  limit_monitoring_group_level: MonitoringGroupLevel,
  limit_monitoring_groups: number,
  LocationsCountLimit: RefObject<LimitCheckerComponent | undefined>,
  LocationTierLimitRef: RefObject<LimitCheckerComponent | undefined>,
  setValue: (value: PropsValue<MonitoringGroup>) => void,
  onChange?: (newValue: OnChangeValue<MonitoringGroup, boolean>, actionMeta: ActionMeta<MonitoringGroup>) => void,
  isMulti?: boolean
) => {
  if (!isMulti) {
    if (onChange) {
      onChange(data, actionMeta);
    }
    setValue(data as PropsValue<MonitoringGroup>);
  } else {
    const numMonitoringGroups = (data as MultiValue<MonitoringGroup>)?.length || 0;
    const aboveTier = actionMeta?.option?.level && actionMeta.option.level > limit_monitoring_group_level;
    if (actionMeta.action === "select-option" && (aboveTier || numMonitoringGroups > limit_monitoring_groups)) {
      const ref = aboveTier ? LocationTierLimitRef : LocationsCountLimit;
      const requestedValue = aboveTier ? actionMeta.option!.id : numMonitoringGroups;
      ref.current?.checkIfLimitHit({requestedValue}).then((isLimitHit) => {
        if (!isLimitHit) {
          if (onChange) {
            onChange(data, actionMeta);
          }
          setValue(data as PropsValue<MonitoringGroup>);
        }
      });
    } else {
      // no limit check required
      if (onChange) {
        onChange(data, actionMeta);
      }
      setValue(data as PropsValue<MonitoringGroup>);
    }
  }
};

export const limitChangesHandlerCurry =
  (
    limit_monitoring_group_level: MonitoringGroupLevel,
    limit_monitoring_groups: number,
    LocationsCountLimit: RefObject<LimitCheckerComponent | undefined>,
    LocationTierLimitRef: RefObject<LimitCheckerComponent | undefined>,
    setValue: (value: PropsValue<MonitoringGroup>) => void,
    onChange?: (newValue: OnChangeValue<MonitoringGroup, boolean>, actionMeta: ActionMeta<MonitoringGroup>) => void,
    isMulti?: boolean
  ) =>
  (data: OnChangeValue<MonitoringGroup, boolean>, actionMeta: ActionMeta<MonitoringGroup>) =>
    limitChangesHandler(
      data,
      actionMeta,
      limit_monitoring_group_level,
      limit_monitoring_groups,
      LocationsCountLimit,
      LocationTierLimitRef,
      setValue,
      onChange,
      isMulti
    );
